import Service from '@/services/abstract/service'
import Functions from '@/utils/functions'
export default class Administrador extends Service {
  constructor() {
    super()
    this._leadRef = this._db.collection(`${this._prefix}-leads`)
    this._veiculoRef = this._db.collection(
      `${this._prefix}-gruposEmpresas/${this._grupoPrincipal}/Veiculos`
    )
    this._empresaRef = this._db.collection(
      `${this._prefix}-gruposEmpresas/${this._grupoPrincipal}/Empresas`
    )
    this._colaboradoresRef = this._db.collection(
      `${this._prefix}-gruposEmpresas/${this._grupoPrincipal}/Colaboradores`
    )
  }

  async getLeadsByTemperatura(empresas, temperatura) {
    try {
      this._loading.setLoading(true, 'Carregando Leads')

      const groupsEmresas = Functions.dividirArray(empresas, 10)

      let leads = new Array()
      for (const group of groupsEmresas) {
        const response = await this._leadRef
          .where('empresa', 'in', group)
          .where('termometro', '==', temperatura)
          .get()

        if (!response.empty) {
          for (let doc of response.docs) {
            leads.push({
              id: doc.id,
              ...doc.data()
            })
          }
        }
      }

      return Promise.resolve(leads)
    } catch (error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }

  async getLeadsByDataCriacao(empresas, dateStart, dateEnd) {
    try {
      this._loading.setLoading(true, 'Carregando Leads')

      const groupsEmresas = Functions.dividirArray(empresas, 10)

      const dataFim = new Date(dateEnd)
      dataFim.setDate(dataFim.getDate() + 1)
      dataFim.setHours(23, 59, 59)

      const dataInicio = new Date(dateStart)
      dataInicio.setDate(dataInicio.getDate() + 1)
      dataInicio.setHours(0)

      let leads = new Array()
      for (const group of groupsEmresas) {
        const response = await this._leadRef
          .where('empresa', 'in', group)
          .where('dataCriacao', '>=', dataInicio)
          .where('dataCriacao', '<=', dataFim)
          .orderBy('dataCriacao', 'desc')
          .get()

        if (!response.empty) {
          for (let doc of response.docs) {
            leads.push({
              id: doc.id,
              ...doc.data()
            })
          }
        }
      }

      return Promise.resolve(leads)
    } catch (error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }

  async getLeadsByDataCriacaoWithoutCompany(dateStart, dateEnd) {
    try {
      this._loading.setLoading(false, 'Carregando Leads')

      const dataFim = new Date(dateEnd)
      dataFim.setDate(dataFim.getDate() + 1)
      dataFim.setHours(23, 59, 59)

      const dataInicio = new Date(dateStart)
      dataInicio.setDate(dataInicio.getDate() + 1)
      dataInicio.setHours(0)

      let leads = new Array()
      //for (const group of groupsEmresas) {
        const response = await this._leadRef
          // .where('empresa', 'in', group)
          .where('dataCriacao', '>=', dataInicio)
          .where('dataCriacao', '<=', dataFim)
          .orderBy('dataCriacao', 'desc')
          .get()

        if (!response.empty) {
          for (let doc of response.docs) {
            leads.push({
              id: doc.id,
              ...doc.data()
            })
          }
        }
      //}

      return Promise.resolve(leads)
    } catch (error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }

  async getLeadsByDataProxContato(empresas, dateStart, dateEnd) {
    try {
      this._loading.setLoading(true, 'Carregando Leads')

      const groupsEmresas = Functions.dividirArray(empresas, 10)

      const dataFim = new Date(dateEnd)
      dataFim.setDate(dataFim.getDate() + 1)
      dataFim.setHours(23, 59, 59)

      const dataInicio = new Date(dateStart)
      dataInicio.setDate(dataInicio.getDate() + 1)
      dataInicio.setHours(0)

      let leads = new Array()
      for (const group of groupsEmresas) {
        const response = await this._leadRef
          .where('empresa', 'in', group)
          .where('dataProxContato', '>=', dataInicio)
          .where('dataProxContato', '<=', dataFim)
          .orderBy('dataProxContato', 'desc')
          .get()

        if (!response.empty) {
          for (let doc of response.docs) {
            leads.push({
              id: doc.id,
              ...doc.data()
            })
          }
        }
      }


      return Promise.resolve(leads)
    } catch (error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }

  async getHistoricoContato(lead) {
    try {
      this._loading.setLoading(true, 'Carregando Historico')
      const response = await this._db
        .collection(`${this._prefix}-leads/${lead.id}/historicoContato`)
        .orderBy('dataContato', 'asc')
        .get()

      let historico = new Array()
      if (!response.empty) {
        for (let doc of response.docs) {
          historico.push({
            id: doc.id,
            ...doc.data()
          })
        }
      }
      return Promise.resolve(historico)
    } catch (error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }

  async getHistoricoMovimentacao(lead) {
    try {
      this._loading.setLoading(true, 'Carregando Historico')
      const response = await this._db
        .collection(`${this._prefix}-leads/${lead.id}/historicoMovimentacao`)
        .orderBy('dataMovimentacao', 'asc')
        .get()

      let historico = new Array()
      if (!response.empty) {
        for (let doc of response.docs) {
          historico.push({
            id: doc.id,
            ...doc.data()
          })
        }
      }
      return Promise.resolve(historico)
    } catch (error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }

  async getEmpresa(lead) {
    try {
      this._loading.setLoading(true, 'Carregando Empresa da Lead')
      const response = await this._empresaRef
        .where('cnpj', '==', lead.empresa)
        .get()

      let empresa = new Array()
      if (!response.empty) {
        for (let doc of response.docs) {
          empresa.push({
            id: doc.id,
            ...doc.data()
          })
        }
      }
      return Promise.resolve(empresa)
    } catch (error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }

  async getColaborador(lead) {
    try {
      this._loading.setLoading(true, 'Carregando Colaborador da Lead')
      const response = await this._colaboradoresRef
        .where('cpf', '==', lead.donoDoLead)
        .get()

      let colaborador = new Array()
      if (!response.empty) {
        for (let doc of response.docs) {
          colaborador.push({
            id: doc.id,
            ...doc.data()
          })
        }
      }
      return Promise.resolve(colaborador)
    } catch (error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }

  async getImagenVeiculo(lead) {
    try {
      this._loading.setLoading(true, 'Carregando Veiculo')

      let veiculo = new Array()
      const response = await this._veiculoRef
        .where('descricao', '==', lead.nomeVeiculo)
        .get()
      if (!response.empty) {
        for (let doc of response.docs) {
          veiculo.push({
            id: doc.id,
            foto: doc.data().foto
          })
        }
      }

      return Promise.resolve(veiculo)
    } catch (error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }
}
